import RadioButtonCheckedIcon from '@mui/icons-material/RadioButtonChecked';
import { NavLink } from 'react-router-dom';

import { isMenuItemActive } from './side-bar.matchers';
import type { SidebarLinkEntry, SidebarMenuItem } from './types';

type RootSidebarLinkProps = {
  entry: SidebarLinkEntry;
  pathname: string;
  onNavigate?: () => void;
};

type ChildSidebarLinkProps = {
  item: SidebarMenuItem;
  pathname: string;
  onNavigate?: () => void;
};

export function RootSidebarLink({
  entry,
  pathname,
  onNavigate,
}: RootSidebarLinkProps) {
  const Icon = entry.icon;
  const isActive = isMenuItemActive(entry, pathname);

  return (
    <NavLink to={entry.to} onClick={onNavigate}>
      <li className={`row ${isActive ? 'active' : ''}`}>
        <div id='icon'>
          <Icon />
        </div>
        <p id='title'>{entry.label}</p>
      </li>
    </NavLink>
  );
}

export function ChildSidebarLink({
  item,
  pathname,
  onNavigate,
}: ChildSidebarLinkProps) {
  const isActive = isMenuItemActive(item, pathname);

  return (
    <NavLink to={item.to} onClick={onNavigate}>
      <li className={`row ${isActive ? 'active' : ''}`}>
        <div id='innerIcon'>
          <RadioButtonCheckedIcon />
        </div>
        <p id='innerTitle' style={{ color: isActive ? '#f3734c' : 'inherit' }}>
          {item.label}
        </p>
      </li>
    </NavLink>
  );
}
